import type {
  MachineProductEntity,
  CreateMachineProductRequest,
  UpdateMachineProductRequest,
} from "../../../domain/types/machine-product";
import { MachineProductEntitySchema } from "../../../domain/types/machine-product";
import type { UnreportedMachineProductEntity } from "../../../domain/types/unreported-machine-product";
import { UnreportedMachineProductEntitySchema } from "../../../domain/types/unreported-machine-product";
import type { AdminMachineProductRepository } from "../../../domain/repositories/admin/admin-machine-product-repository";
import { adminMachineProductApiService } from "../../api/admin/admin-machine-product-api-service";

export class AdminMachineProductRepositoryImpl
  implements AdminMachineProductRepository
{
  async getAll(): Promise<MachineProductEntity[]> {
    const response = await adminMachineProductApiService.getAll();
    if (response.data) {
      return response.data.map((item) =>
        MachineProductEntitySchema.parse(item)
      );
    }
    throw new Error(response.errorMsg || "장비 제품 목록 조회 실패");
  }

  async getById(id: number): Promise<MachineProductEntity> {
    const response = await adminMachineProductApiService.getById(id);
    if (response.data) {
      return MachineProductEntitySchema.parse(response.data);
    }
    throw new Error(response.errorMsg || "장비 제품 상세 조회 실패");
  }

  async create(
    request: CreateMachineProductRequest
  ): Promise<MachineProductEntity> {
    const response = await adminMachineProductApiService.create(request);
    if (response.data) {
      return MachineProductEntitySchema.parse(response.data);
    }
    throw new Error(response.errorMsg || "장비 제품 생성 실패");
  }

  async update(
    id: number,
    request: UpdateMachineProductRequest
  ): Promise<MachineProductEntity> {
    const response = await adminMachineProductApiService.update(id, request);
    if (response.data) {
      return MachineProductEntitySchema.parse(response.data);
    }
    throw new Error(response.errorMsg || "장비 제품 수정 실패");
  }

  async delete(id: number): Promise<boolean> {
    const response = await adminMachineProductApiService.delete(id);
    if (response.data !== undefined) {
      return response.data;
    }
    throw new Error(response.errorMsg || "장비 제품 삭제 실패");
  }

  async getAllUnreported(): Promise<UnreportedMachineProductEntity[]> {
    const response = await adminMachineProductApiService.getAllUnreported();
    if (response.data) {
      return response.data.map((item) =>
        UnreportedMachineProductEntitySchema.parse(item)
      );
    }
    throw new Error(response.errorMsg || "미보고 장비 목록 조회 실패");
  }

  async getUnreportedById(
    id: number
  ): Promise<UnreportedMachineProductEntity> {
    const response =
      await adminMachineProductApiService.getUnreportedById(id);
    if (response.data) {
      return UnreportedMachineProductEntitySchema.parse(response.data);
    }
    throw new Error(response.errorMsg || "미보고 장비 상세 조회 실패");
  }

  async deleteUnreported(id: number): Promise<boolean> {
    const response =
      await adminMachineProductApiService.deleteUnreported(id);
    if (response.data !== undefined) {
      return response.data;
    }
    throw new Error(response.errorMsg || "미보고 장비 삭제 실패");
  }
}